import { BorderGridContainer, GridBox, Step, Stepper, TypeWrapper } from '@ahmdigital/ui';
import { PRODUCT_TYPE } from '@ahmdigital/constants';
import { useSelector } from 'react-redux';
import React from 'react';
import styled from 'styled-components';

import { JourneyProductType } from './types';
import { ProductType } from '../../types/__codegen__/ahm-api/graphql';
import { RootState } from '../../reducers';
import { STEPS } from './constants';
import AboutYou from './steps/about-you';
import ahmConstants from '../../ahm-constants';
import ChooseYourCover from './steps/choose-your-cover';
import getSteps from './utils/get-steps';
import Head from '../../../utils/head';
import PriceBar from './components/price-bar';
import selectBuildYourCover from '../../selectors/select-build-your-cover';
import selectCustomer from '../../selectors/select-customer';
import ServiceSelectionWithDataLoader from './steps/service-selection-with-data-loader';
import StepHeaderNavigation from './components/step-header-navigation';
import Welcome from './steps/welcome';

const Footer = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-top: 1px solid ${({ theme }) => theme.colors.grey30};
  box-shadow: 0px -7px 20px 0px rgba(0, 0, 0, 0.15);
  margin-top: -0.5rem;
  bottom: -0.5rem;
  position: sticky;
  z-index: ${({ theme }) => theme.zIndices.footer};

  @media (min-width: ${({ theme }) => theme.media.md}) {
    border: none;
  }
`;

export type BuildYourCoverProps = {
  journeyProductType?: JourneyProductType;
};

const BuildYourCover = ({ journeyProductType = PRODUCT_TYPE.PACKAGE }: BuildYourCoverProps) => {
  const { activeStep } = useSelector(selectBuildYourCover);
  const { hasRefinedPrice } = useSelector(selectCustomer);
  const isFromRefinePrice =
    useSelector((state: RootState) => state.history[1]) === ahmConstants.URLS.SALES.REFINE_PRICE;

  const { skipSplashScreen, steps } = getSteps(isFromRefinePrice, hasRefinedPrice, journeyProductType);

  return (
    <>
      <Head>
        <title>Choose your own cover</title>
        <meta key="robots" name="robots" content="noindex, nofollow" />
      </Head>
      <BorderGridContainer hideBorderTop>
        <GridBox padding="0 0 1rem 0">
          <TypeWrapper variant="marginBottomSpacer6">
            {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type 'string | null' is not assignable to type 'string | number | undefined'. */}
            <Stepper initialStep={activeStep} steps={steps}>
              <StepHeaderNavigation
                hasStepZero={!skipSplashScreen}
                journeyProductType={journeyProductType}
                isFromRefinePrice={isFromRefinePrice}
                hasRefinedPrice={hasRefinedPrice}
              />
              {!skipSplashScreen && (
                // @ts-expect-error [🤖 PLEASE FIX 🤖]: 'Step' cannot be used as a JSX component.
                <Step name={STEPS.SPLASH_SCREEN}>
                  <Welcome />
                </Step>
              )}
              {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: 'Step' cannot be used as a JSX component. */}
              <Step name={STEPS.ABOUT_YOU}>
                <AboutYou />
              </Step>
              {journeyProductType !== PRODUCT_TYPE.EXTRAS && (
                // @ts-expect-error [🤖 PLEASE FIX 🤖]: 'Step' cannot be used as a JSX component.
                <Step name={STEPS.HOSPITAL_SERVICES}>
                  <ServiceSelectionWithDataLoader productType={ProductType.Hospital} />
                </Step>
              )}
              {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: 'Step' cannot be used as a JSX component. */}
              <Step name={STEPS.EXTRAS_SERVICES}>
                <ServiceSelectionWithDataLoader productType={ProductType.Extras} />
              </Step>
              {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: 'Step' cannot be used as a JSX component. */}
              <Step name={STEPS.CHOOSE_THE_COVER}>
                <ChooseYourCover journeyProductType={journeyProductType} />
              </Step>
            </Stepper>
          </TypeWrapper>
        </GridBox>
        {activeStep === STEPS.CHOOSE_THE_COVER && (
          <Footer>
            <PriceBar journeyProductType={journeyProductType} />
          </Footer>
        )}
      </BorderGridContainer>
    </>
  );
};

export default BuildYourCover;
